import React, { useEffect } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import {
  ChevronDown,
  User,
  Users,
  Baby,
  ChevronRight,
  Circle,
} from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCollectionDetail } from "../../redux/actions/collectionActions";
import { elements } from "chart.js";

function CategoriesDropdown() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((state) => state.collection);

  useEffect(() => {
    dispatch(getCollectionDetail("all"));
  }, []);

  const navLinkBase = `block px-2 flex items-center gap-3 py-2 rounded transition-colors font-medium`;
  const activeStyles = `bg-normal-theme-color text-white`;
  const inactiveStyles = `text-black hover:bg-normal-theme-color hover:text-white `;

  // List all routes that should highlight "Categories"
  const categoryRoutes = [
    "/collections/mens",
    "/collections/womens",
    "/collections/kids",
  ];
  const isCategoryActive = categoryRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <div>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button
            className={`flex items-center px-3 py-1 gap-1 rounded-3xl transition 
                      hover:bg-normal-theme-color hover:text-white focus:outline-none focus-visible:outline-none
                      ${
                        isCategoryActive
                          ? "bg-normal-theme-color text-white"
                          : "text-black"
                      }`}
          >
            <span className="font-semibold ">Categories</span>
            <ChevronDown className="w-4 h-4" strokeWidth={1.8} />
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Content
          className="z-50 flex flex-col w-45 my-3 rounded-2xl bg-[#fdf5f5] p-4 shadow-xl animate-fade-in focus:outline-none"
          align="start"
          sideOffset={8}
        >
          {items?.length > 0 &&
            items.map((category) => (
              <div key={category.cat_name}>
                <DropdownMenu.Sub>
                  <DropdownMenu.SubTrigger
                    className="flex items-center gap-4 rounded hover:bg-muted focus:outline-none cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Optional: Prevents dropdown closing too early
                      navigate(`/collections/${category.cat_name}`);
                    }}
                  >
                    <Circle className="w-2 h-2" color="#008083" />
                    {category.cat_name}
                    <div className="ml-auto">
                      <ChevronRight className="w-5 h-5" />
                    </div>
                  </DropdownMenu.SubTrigger>

                  <DropdownMenu.Portal>
                    <DropdownMenu.SubContent
                      className="z-50 flex flex-col w-45 my-3 rounded-2xl bg-[#fdf5f5] pl-3 pr-3 pt-3 pb-3 shadow-xl animate-fade-in focus:outline-none"
                      sideOffset={23}
                      alignOffset={-5}
                    >
                      {category?.subcategories?.map((item) => {
                        return (
                          <DropdownMenu.Item
                            asChild
                            key={item.label}
                            className="flex my-1 items-center gap-4 rounded hover:bg-muted focus:outline-none"
                          >
                            <NavLink
                              to={`/products?catId=${
                                category?.cat_id
                              }&category=${encodeURIComponent(
                                category?.cat_name
                              )}&subCatId=${
                                item?.sub_cat_id
                              }&subCategory=${encodeURIComponent(
                                item?.sub_cat_name
                              )}`}
                              className={({ isActive }) =>
                                `${navLinkBase} ${
                                  isActive ? activeStyles : inactiveStyles
                                }`
                              }
                            >
                              <Circle className="w-2 h-2" color="#008083" />
                              {item?.sub_cat_name}
                              <div className="ml-auto">
                                <ChevronRight className="w-5 h-5" />
                              </div>
                            </NavLink>
                          </DropdownMenu.Item>
                        );
                      })}
                    </DropdownMenu.SubContent>
                  </DropdownMenu.Portal>
                </DropdownMenu.Sub>

                <div className="h-2" />
              </div>
            ))}
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}

export default CategoriesDropdown;
